var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play btn-video"},[_c('span',{staticClass:"icon-wrap"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fa', 'play']}})],1),_vm._v("Ver Video")])}
var staticRenderFns = []

export { render, staticRenderFns }